import React from 'react';
import { Plugins } from '@leverege/plugin';
import BulkCreateUploadForm from "./BulkCreateUploadForm.js";
import BulkCreateResults from "./BulkCreateResults.js";
export const BulkBlueprintFormFactory = Plugins.createFactory('BulkBlueprintForm', {
  strategy: Plugins.reactStrategy(React, 'type'),
  pluginKey: 'form',
  defaultObject: BulkCreateUploadForm
});
export const BulkBlueprintResultsFactory = Plugins.createFactory('BulkBlueprintResults', {
  strategy: Plugins.reactStrategy(React, 'type'),
  pluginKey: 'form',
  defaultObject: BulkCreateResults
});